<template>
    <div>
        <!-- <alert-loading></alert-loading> -->
        <b-row align-h="between">
            <b-col>
                <date-range-picker v-model="reportRange"></date-range-picker>
            </b-col>
            <b-col class="text-right">
                <b-button variant="default" @click.prevent="downloadReport()">
                <span>Generuj XLS</span>
                <svg-icon name="download"/>
                </b-button>
            </b-col>
        </b-row>
        <alert-loading v-if="loading"></alert-loading>
        <div  v-if="!loading" class="table-responsive">
            <table class="table table-striped table-bordered table-hover table-clickable table-search">
                <thead>
                <tr>
                    <th>Numer faktury</th>
                    <th>Korekta</th>
                    <th>Data dodania</th>
                    <th>Nazwa klienta</th>
                    <th>Netto ({{currency.name}})</th>
                    <th>Brutto ({{currency.name}})</th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="invoice in items.list">
                        <td class="td-no_link">{{invoice.fullNumber}}</td>
                        <td class="td-no_link">{{invoice.correction| translate}}</td>
                        <td class="td-no_link">{{invoice.date.date | date}}</td>
                        <td class="td-no_link">{{invoice.customerName}}</td>
                        <td class="td-no_link">{{invoice.net|amountFormat}}</td>
                        <td class="td-no_link">{{invoice.gross|amountFormat}} </td>
                    </tr>
                </tbody>
                <tfoot>
                <tr class="tr-summary">
                    <td colspan="4" class="td-no_link text-right">Suma</td>
                    <td class="td-no_link"><strong>{{items.totalNet|amountFormat}} </strong></td>
                    <td class="td-no_link"><strong>{{items.totalGross|amountFormat}} </strong></td>
                </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import moment from 'moment'
  import http from './../../utils/http'

  export default {
    props: {
      currency: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        reportRange: null,
      }
    },

    methods: {
      downloadReport(){
        const to =  moment(this.reportRange[1]).format('YYYY-MM-DD')
        const from = moment(this.reportRange[0]).format('YYYY-MM-DD')
        http.download('/download/reports/invoice/' + this.currency.id + '?from=' + from + '&to=' + to + '&');
      },
      ...mapActions({
        getItems: 'report/invoice/getItems'
      })
    },

    computed: {
      ...mapGetters({
        items: 'report/invoice/items',
        loading: 'report/invoice/loading',
        errors: 'report/invoice/errors',
      })
    },
    watch:{
      reportRange: function (data) {
        this.getItems({ currency: this.currency, from: this.reportRange[0], to: this.reportRange[1]} )
      }
    },
    created () {
      if(!this.reportRange){
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        this.reportRange = [
          start,
          end
        ];
      }
    }
  }
</script>


// WEBPACK FOOTER //
// Invoice.vue?b2bcf774